import { lazy } from 'react';
import { Navigate } from 'react-router';
import { ErrorPage } from '@/components/ErrorPage';
import Loadable from '@/components/loadable';
import { AuthGuard } from '@/components/AuthGuard';
import { RootLayout } from '@/layouts/RootLayout';

const DashboardLayout = Loadable(lazy(() => import('@/pages/dashboard/layout')));
const DronesPage = Loadable(lazy(() => import('@/pages/dashboard/drones-page')));
const DroneAppsPage = Loadable(lazy(() => import('@/pages/dashboard/drone-apps-page')));
const InstallAppPage = Loadable(lazy(() => import('@/pages/dashboard/install-app-page')));
const DroneLogsPage = Loadable(lazy(() => import('@/pages/dashboard/drone-logs-page')));
const SessionInfoPage = Loadable(lazy(() => import('@/pages/dashboard/session-info-page')));
const LiveSessionsPage = Loadable(lazy(() => import('@/pages/dashboard/live-sessions-page')));
const AppsLeaderboard = Loadable(lazy(() => import('@/pages/dashboard/apps-leaderboard')));
const ControllerCheckPage = Loadable(lazy(() => import('@/pages/dashboard/controller-check-page')));
const FpvSimPage = Loadable(lazy(() => import('@/pages/dashboard/fpv-sim-page')));
const MissionEditorPage = Loadable(lazy(() => import('@/pages/dashboard/mission-editor-page')));
const MissionsPage = Loadable(lazy(() => import('@/pages/dashboard/missions-page')));
const SwarmPage = Loadable(lazy(() => import('@/pages/dashboard/swarm-page')));
const SwarmBehaviorsPage = Loadable(lazy(() => import('@/pages/dashboard/swarm-behaviors-page')));
const TriggerTemplatesPage = Loadable(
  lazy(() => import('@/pages/dashboard/trigger-templates-page')),
);
const ImageAnnotationsPage = Loadable(
  lazy(() => import('@/pages/dashboard/image-annotations-page')),
);
const TrainingJobsPage = Loadable(lazy(() => import('@/pages/dashboard/training-jobs-page')));

const DashboardRoutes = {
  path: '/dashboard',
  element: <DashboardLayout />,
  children: [
    {
      element: (
        <AuthGuard>
          <ErrorPage />
        </AuthGuard>
      ),
    },
    {
      path: '',
      element: (
        <AuthGuard>
          <RootLayout />
        </AuthGuard>
      ),
      children: [
        { index: true, element: <Navigate to="/dashboard/drones" replace /> },
        { path: 'apps', element: <Navigate to="/dashboard/apps-leaderboard" replace /> },
        { path: 'apps-leaderboard', element: <AppsLeaderboard /> },
        { path: 'drones', element: <DronesPage /> },
        { path: 'drones/:droneId/apps', element: <DroneAppsPage /> },
        { path: 'drones/:droneId/apps/install', element: <InstallAppPage /> },
        { path: 'drones/:droneId/logs', element: <DroneLogsPage /> },
        { path: 'live-sessions', element: <LiveSessionsPage /> },
        { path: 'live-sessions/:droneId', element: <LiveSessionsPage /> },
        { path: 'controller-check', element: <ControllerCheckPage /> },
        { path: 'fpv-sim', element: <FpvSimPage /> },
        { path: 'sessions/:droneId', element: <SessionInfoPage /> },
        { path: 'sessions/:droneId/:sessionId', element: <SessionInfoPage /> },
        { path: 'swarm', element: <SwarmPage /> },
        { path: 'missions', element: <MissionsPage /> },
        { path: 'missions/new', element: <MissionEditorPage /> },
        { path: 'missions/:missionId', element: <MissionEditorPage /> },
        { path: 'trigger-templates', element: <TriggerTemplatesPage /> },
        { path: 'swarm-behaviors', element: <SwarmBehaviorsPage /> },
        { path: 'image-annotations', element: <ImageAnnotationsPage /> },
        { path: 'training-jobs', element: <TrainingJobsPage /> },
      ],
    },
  ],
};

export default DashboardRoutes;
